module.exports = __webpack_public_path__ + "static/img/15.e4d23ad.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_right_icon/15.png
// module id = Uqcx
// module chunks = 1